import { defineMessages } from 'react-intl';
const i18nKey = 'GlobalNav';
const messages = defineMessages({
  pricesTab: {
    id: `${i18nKey}.pricesTab`,
    defaultMessage: 'Cryptocurrencies',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Link to prices page`
  },
  pricesTabUK: {
    id: `${i18nKey}.pricesTabUK`,
    defaultMessage: 'Explore',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Link to prices page`
  },
  web3Tab: {
    id: `${i18nKey}.web3`,
    defaultMessage: 'Onchain',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Link to web3 onchain page (CharLimit autocalculated to 40)`
  },
  individualsTab: {
    id: `${i18nKey}.individualsTab`,
    defaultMessage: 'Individuals',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Link to consumer coinbase products (CharLimit autocalculated to 45)`
  },
  businessesTab: {
    id: `${i18nKey}.businessesTab`,
    defaultMessage: 'Businesses',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Link to institutional Coinbase products (CharLimit autocalculated to 45)`
  },
  institutionsTab: {
    id: `${i18nKey}.institutionsTab`,
    defaultMessage: 'Institutions',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Link to institutional Coinbase products`
  },
  developersTab: {
    id: `${i18nKey}.developersTab`,
    defaultMessage: 'Developers',
    description: `
    #Component: LEGACY
    #CharLimit: 45
    #Context: Link to Coinbase developers pages (CharLimit autocalculated to 45)`
  },
  companyTab: {
    id: `${i18nKey}.companyTab`,
    defaultMessage: 'Company',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Link to pages about Coinbase company (CharLimit autocalculated to 40)`
  },
  signInLink: {
    id: `${i18nKey}.signInLink`,
    defaultMessage: 'Sign in',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Link to sign in to your coinbase account (CharLimit autocalculated to 40)`
  },
  signUpLink: {
    id: `${i18nKey}.signUpLink`,
    defaultMessage: 'Sign up',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Button text to start sign up flow (CharLimit autocalculated to 40)`
  },
  skipToContent: {
    id: `${i18nKey}.skipToContent`,
    defaultMessage: `Skip to content`,
    description: `
    #Component: LEGACY
    #CharLimit: 50
    #Context: Link to skip menu and go to content (CharLimit autocalculated to 50)`
  },
  skipToTableOfContents: {
    id: `${i18nKey}.skipToTableOfContents`,
    defaultMessage: `Skip to site index`,
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Link to skip menu and main content, to site index (CharLimit autocalculated to 55)`
  },
  ariaMobileMenuOpen: {
    id: `${i18nKey}.ariaMobileMenuOpen`,
    defaultMessage: `open navigation menu`,
    description: `
    #Component: LEGACY
    #CharLimit: 55
    #Context: Accessibility label explaining to the user that clicking on the icon will open the menu on mobile (CharLimit autocalculated to 55)`
  },
  ariaMobileMenuClose: {
    id: `${i18nKey}.ariaMobileMenuClose`,
    defaultMessage: `close navigation menu`,
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Accessibility label explaining to the user that clicking on the icon will close the menu on mobile (CharLimit autocalculated to 60)`
  },
  ariaLanguageSelector: {
    id: `${i18nKey}.ariaLanguageSelector`,
    defaultMessage: `open language selector`,
    description: `
    #Component: LEGACY
    #CharLimit: 60
    #Context: Accessibility label explaining to the user that clicking on the icon will open the language selector (CharLimit autocalculated to 60)`
  },
  ariaGlobalPreferences: {
    id: `${i18nKey}.globeAccessabilityLabel`,
    defaultMessage: 'Open global preferences',
    description: `
      #Component: Button:accessibilityLabel
      #CharLimit: 100
      #Context: accessibility label for the globe button to open the global preferences modal`
  },
  ukFinPromComplianceBanner: {
    id: `${i18nKey}.ukFinPromComplianceBanner`,
    defaultMessage: `Don’t invest unless you’re prepared to lose all the money you invest. This is a high-risk investment and you should not expect to be protected if something goes wrong. Take 2 mins to learn more.`,
    description: `
    #Component: LEGACY
    #CharLimit: 290
    #Context: Banner message for UK users to comply with FCA financial promotion rules (CharLimit autocalculated to 290)`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
